// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Fb1J","nested":"Note_nested__YK5U-"};